/**
 * Created by fyzu on 27.07.16.
 */


var AppService = (function () {

    'use strict';

    //************ Variables ************//
    var generalTab = null;
    var currentCity = null;
    var tab = {
        CATEGORY: "category",
        FAVORITES: "favorites"
    };
    var timeoutHandler = null;
    var loader = false;

    //************ Functions ************//
    function getGeneralTab() {
        if (generalTab === null) {
            generalTab = $('.js-general-tab').data('generalTab');
        }
        return generalTab;
    }

    function getCurrentCity() {
        if (currentCity == null) {
            currentCity = $('.js-city-title').text();
        }
        return currentCity;
    }

    function headerFix(){
        const headerHeight = $("#navbarFixedTop").height();
        $('.js-general-tab').css('padding-top', headerHeight);
    }

    function refresh(time) {
        if (timeoutHandler !== null) {
            clearTimeout(timeoutHandler);
        }
        setTimeout(function () {
            location.reload();
            timeoutHandler = null;
        }, time ? time : 1000);
    }

    function redirectTo(link) {
        $(location).attr('href', link);
    }

    function redirectToHome() {
        $(location).attr('href', '/');
    }

    function redirectToBack() {
        window.history.back();
    }

    function recaptchaInit() {
        CommercialService.init();
        GuestBookService.init();
    }

    function toggleLoader() {
        if (loader) {
            $('.loader').remove();
        } else {
            $('body').append('<div class="loader"><div class="loader-animation"></div></div>');
        }

        loader = !loader;
    }

    function enableLoader() {
        $('body').append('<div class="loader"><div class="loader-animation"></div></div>');
        loader = true;
    }

    function disableLoader() {
        $('.loader').remove();
        loader = false;
    }

    function displayError(errorMsg, input) {
        var $input = $(input);
        var formGroup = $input.parent();
        formGroup.addClass('has-error');
        if (errorMsg) {
            if (formGroup.find('.help-block').length == 0) {
                formGroup.append('<span class="help-block"></span>');
            }
            formGroup.find('.help-block').html(errorMsg);
        }
    }

    function displayErrorOnLoginScreen(errorMsg, input) {
        var $input = $(input);
        var formGroup = $input.parent();
        formGroup.addClass('has-error');
        if (formGroup.find('.help-block').length == 0) {
            formGroup.append('<span class="help-block mod-login"></span>');
        }
        formGroup.find('.help-block').html(errorMsg);
    }

    function deleteError(input) {
        var $input = $(input);
        var formGroup = $input.parent();
        formGroup.removeClass('has-error');
        formGroup.find('.help-block').remove();
    }

    function parseErrors(data, moduleName) {
        if (data == null) {
            console.error('not valid data');
            return;
        }

        $('.help-block').remove();
        $('.has-error').removeClass('has-error');

        var baseInputName = 'js-input-';
        if (moduleName != null) {
            baseInputName += moduleName + '-';
        }

        if (data.errors != null) {
            $.each(data.errors, function (field, errors) {
                var selector = '.' + baseInputName + field
                    + ', #' + baseInputName + field;

                var errorMsg = '';
                $.each(errors, function (index, error) {
                    errorMsg += error + '<br/>';
                });

                displayError(errorMsg, $(selector));
            });
        }
    }

    function parseErrorsOnLoginScreen(data, moduleName) {
        if (data == null) {
            console.error('not valid data');
            return;
        }

        $('.help-block').remove();
        $('.has-error').removeClass('has-error');

        var baseInputName = 'js-input-';
        if (moduleName != null) {
            baseInputName += moduleName + '-';
        }

        if (data.errors != null) {
            $.each(data.errors, function (field, errors) {
                var selector = '.' + baseInputName + field
                    + ', #' + baseInputName + field;

                var errorMsg = '';
                $.each(errors, function (index, error) {
                    errorMsg += error + '<br/>';
                });

                displayErrorOnLoginScreen(errorMsg, $(selector));
            });
        }
    }

    function initJivosite() {
        try {
            if (typeof jivosite_widget_id != 'undefined' && jivosite_widget_id != ''
                && !/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {

                var s = document.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = '//code.jivosite.com/script/widget/' + jivosite_widget_id;
                var ss = document.getElementsByTagName('script')[0];
                ss.parentNode.insertBefore(s, ss);
            }
        } catch (ignore) {

        }
    }

    function swipeOnAboutPage() {
        if ($('main.content').attr('data-general-tab') === 'about') {
            $(document).ready(function () {
                $("#carousel-about").swiperight(function () {
                    $(this).carousel('prev');
                });
                $("#carousel-about").swipeleft(function () {
                    $(this).carousel('next');
                });
            });
        }
    }

    function showCookiesDisclaimer() {
        $(document).ready(function () {
            var disclaimerModal = $('.js-cookies');
            var disclaimer = localStorage.getItem('disclaimer');

            if (disclaimer === null) {
                disclaimerModal.show();
            }

            $('.js-disclaimer-disagree-btn').click(function () {
                AppService.redirectTo('/blank_page');
            });

            $('.js-disclaimer-agree-btn').click(function () {
                localStorage.setItem('disclaimer', 'notNull');
                disclaimerModal.hide();
            });
        });
    }

    // function showAppDownloadBanner() {
    //     $(document).ready(function () {
    //         var banner = localStorage.getItem('banner');
    //
    //         if (banner === null) {
    //             $("#navbarFixedTop").addClass("navbar-with-download-link");
    //             $(".content").addClass("content-mobile-banner");
    //         }
    //
    //         $('.js-close-button').click(function () {
    //             localStorage.setItem('banner', 'notNull');
    //             $(".navbar-with-download-link").removeClass("navbar-with-download-link");
    //             $("#appContainer").remove();
    //             $(".content").removeClass("content-mobile-banner");
    //         });
    //
    //     });
    // }

    /**
     * Обязывает юзера выбирать только из списка, не давая ему ввести свой произвольный текст
     * @param element Поле куда юзер вводит текст
     * @param hiddenInput Скрытое поле куда ставится значение при клике из предложений списка
     * @param itemDataTagName Как называется дата тег у айтема из выпадающего списка
     * @param validationValue Массив со следующей структурой {value: Boolean,change: Function},
     * value обозначает выбрал ли юзер элемент из списка
     * change вызывается когда устанавливается переменная (element, showElement)
     */
    function onlyAutoCompleteListElement(element, hiddenInput, itemDataTagName, validationValue = {}) {
        let autoComplete = element.data("ac");
        if (!autoComplete || !autoComplete.options)
            return;
        let oldSelect = autoComplete.options.onSelect;
        if (!oldSelect)
            oldSelect = function () {
            };
        autoComplete.options.onSelect = function (e, term, item) {
            oldSelect(e, term, item);
            hiddenInput.val(item.data(itemDataTagName));
            setTimeout(() => autoComplete.self.blur(), 50);
        };
        element.click(function () {
            // Поскольку element может быть не один, на всякий случай получим то по чему кликнули
            let currentElement = $(this);
            // Если введено какое то значение И значение поля ДаДата пусто
            // то показываем окошко при клике
            if (currentElement.val() && !hiddenInput.val()) {
                autoComplete.show();
            }
        });
        element.on('input', function () {
            // Если юзер как то изменял поле, то обнуляем кладр
            hiddenInput.val("");
            // Поле не проходит валидацию, так как было измененно
            validationValue.value = false;
        });
        element.blur(function () {
            let blurElement = $(this);
            // Если ничего не написано
            if (!blurElement.val()) {
                validationValue.value = false;
                if (validationValue.change)
                    validationValue.change(blurElement, false);
            }
            // Если что то написано, но это не не выбранно из списка
            else if (!hiddenInput.val()) {
                validationValue.value = false;
                if (validationValue.change)
                    validationValue.change(blurElement, true);
            }
            // Если юзер выбрал элемент из списка
            else {
                deleteError(blurElement);
                validationValue.value = true;
                if (validationValue.change)
                    validationValue.change(blurElement, false);
            }
        });
    }

    function init() {

        $.ajaxSetup({cache: false});

        swipeOnAboutPage();

        showCookiesDisclaimer();

        $('.js-close-modals').click(function () {
            $('.modal.in').modal('hide');
        });

        $('.js-not-available').click(function () {
            $('.js-category-name').text($(this).find('.js-category-item-caption-title').data('label'));
            $('.modal.in').modal('hide');
            $('#modalError').modal('show');
        });

        $('.js-navbar-collapse').click(function () {
            $('#js-navbar-toggle-button').toggleClass("collapsed");
            $('#js-navbar-collapse').toggleClass('in');
            if ($('#js-navbar-collapse').hasClass('in')) {
                $('html').css({overflow: 'hidden'});
            } else {
                $('html').css({overflow: 'auto'});
            }
        });

        $('.js-dropify').dropify({
            messages: {
                'default': 'Перенесите файл или кликните',
                'replace': 'Перенесите файл или кликните для замены',
                'remove': 'Удалить',
                'error': 'Случилась ошибка.'
            },

            tpl: {
                wrap: '<div class="dropify-wrapper"></div>',
                loader: '<div class="dropify-loader"></div>',
                message: '<div class="dropify-message"><span class="dropify-render"><img src="/static/sv/img/profile/avatar.png"></span></div>',
                preview: '<div class="dropify-preview"><span class="dropify-render"></span><div class="dropify-infos"><div class="dropify-infos-inner"><p class="dropify-infos-message">{{ replace }}</p></div></div></div>',
                filename: '',
                clearButton: '<button type="button" class="dropify-clear js-remove-avatar">{{ remove }}</button>',
                errorLine: '<p class="dropify-error">{{ error }}</p>',
                errorsContainer: '<div class="dropify-errors-container"><ul></ul></div>'
            }
        });

        $(window).load(function () {
            $('.dropify-clear').click(function () {
                $('.js-up-remove-avatar').val(true);
            });
        });


        // Redirect to url without port
        if (location.port && location.hostname != 'localhost' && location.hostname != 'web.develop.com') {
            redirectTo(location.href.replace(':' + location.port, ''));
        }


        // $("input[type='tel']").inputmask("+7 999 999-99-99");
        $('#phonePickup').inputmask("+7 999 999-99-99");
        $('#phoneCourier').inputmask("+7 999 999-99-99");
        $('#phone').inputmask("+7 999 999-99-99");
        $('#regphone').inputmask("+7 999 999-99-99");
        $('#js-input-profile-edit-phone').inputmask("+7 999 999-99-99");
        $('.js-mod-add-profile-phone').inputmask("+7 999 999-99-99");
        $('.js-input-login-phone').inputmask("+7 999 999-99-99");
        // $("input[type='tel']").keypress(function () {
        //     var value = $(this).val();
        //     if (value == "+7 8__ ___-__-__") {
        //         $("input[type='tel']").inputmask("+7 999 999-99-99-9",{ "oncomplete": function(){ alert('inputmask complete'); } });
        //     }
        //     if (value == "+7 7__ ___-__-__") {
        //         $("input[type='tel']").inputmask("+7 999 999-99-99-9",{ "oncomplete": function(){ alert('inputmask complete'); } });
        //     }
        //     if (value == "+7 9__ ___-__-__-_") {
        //         $("input[type='tel']").inputmask("+7 999 999-99-99",{ "oncomplete": function(){ alert('inputmask complete'); } });
        //     }
        // });

        initJivosite();

        headerFix();

        window.onresize = function (event) {
            headerFix();
        };

        // Показывает баннер с предложением открыть приложение
        new SmartBanner({
            daysHidden: 14,
            daysReminder: 14,
            appStoreLanguage: 'ru',
            title: 'БлинБери',
            author: 'Быстрая доставка еды',
            button: 'Скачать',
            store: {
                ios: '',
                android: '',
                windows: ''
            },
            icon: '/static/sv/img/app-logo.png' // full path to icon image if not using website icon image
        });
    }

    //************ Public ************//
    return {
        tab: tab,
        init: init,
        toggleLoader: toggleLoader,
        enableLoader: enableLoader,
        disableLoader: disableLoader,
        recaptchaInit: recaptchaInit,
        getGeneralTab: getGeneralTab,
        getCurrentCity: getCurrentCity,
        refresh: refresh,
        redirectTo: redirectTo,
        redirectToHome: redirectToHome,
        redirectToBack: redirectToBack,
        displayError: displayError,
        displayErrorOnLoginScreen: displayErrorOnLoginScreen,
        parseErrorsOnLoginScreen: parseErrorsOnLoginScreen,
        parseErrors: parseErrors,
        deleteError: deleteError,
        onlyAutoCompleteListElement: onlyAutoCompleteListElement
    };
})();

var onReCaptchaLoad = AppService.recaptchaInit;
$(AppService.init);

$(document).ready(function () {
    var i = $('.js-refresh');
    i.val() == 'yes' ? location.reload(true) : i.val('yes');
});